module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEW YORK UNIVERSITY PRESS")]), _c('br'), _vm._v("New York and London")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 1999 by New York University"), _c('br'), _vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("Andrews, Marcellus, 1956–"), _c('br'), _vm._v("The political economy of hope and fear : capitalism and the"), _c('br'), _vm._v("Black condition in America / Marcellus Andrews."), _c('br'), _vm._v("p.   cm."), _c('br'), _vm._v("Includes bibliographical references (p. ) and index."), _c('br'), _vm._v("ISBN 0-8147-0679-7 (acid-free paper)"), _c('br'), _vm._v("1. Afro-Americans—Economic conditions.    2. United"), _c('br'), _vm._v("States—Economic conditions—1945–   3. Capitalism—United"), _c('br'), _vm._v("States—History—20th century.   4. United States—Economic"), _c('br'), _vm._v("policy."), _c('br'), _vm._v("I. Title."), _c('br'), _vm._v("E185.8. A77    1999"), _c('br'), _vm._v("330.973’09—dc21                98-58107"), _c('br'), _vm._v("                                                     CIP")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("New York University Press books are printed on acid-free paper,"), _c('br'), _vm._v("and their binding materials are chosen for strength and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-386a71d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02_copy.vue
// module id = 63
// module chunks = 0